import React, { memo, useCallback, useState } from "react";
import { useI18n } from "Hooks";
import { ToggleSwitch } from "@toddle-edu/ds-web";
import { FILTER_TYPES } from "AppComponents/DatasetTaggingBody/modules/Constants";
import classes from "./HideLockedToggle.scss";
import { useFilters } from "AppComponents/DatasetTaggingBody/providers/FilterProvider";

const TEST_ID_PREFIX = "datasetTaggingBody-standards-hideLocked";

const HideLockedToggle = props => {
  const { hasLockedEdges, learningCourseId } = props;
  const [checked, setChecked] = useState(false);
  const { t } = useI18n(["common"]);

  const { handleApplyFilters } = useFilters();

  const handleChange = useCallback(
    e => {
      const isChecked = e.target.checked;
      setChecked(isChecked);
      handleApplyFilters({
        [FILTER_TYPES.HIDE_LOCKED]: {
          hideLocked: isChecked,
          learningCourseId,
        },
      });
    },
    [handleApplyFilters, learningCourseId]
  );

  if (!hasLockedEdges && !checked) return null;

  return (
    <div className={classes.container}>
      <div className={classes.switchContainer}>
        <div className="text-label">
          {t("common:hide_locked_label", {
            label: t("common:standard_plural"),
          })}
        </div>
        <ToggleSwitch
          onChange={handleChange}
          checked={checked}
          testId={TEST_ID_PREFIX}
        />
      </div>
      <div className={classes.separator} />
    </div>
  );
};

export default memo(HideLockedToggle);
